import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import { useParams } from 'react-router';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router';
import { useEffect } from 'react';
import moment from 'moment';
import { getApi } from 'views/services/api';
import AddHotel from '../AddHotel';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'left',
  color: theme.palette.text.secondary
}));

export default function HotelManagementDashboard() {
  const navigate = useNavigate();
  const [value, setValue] = useState('1');
  const [openAdd, setOpenAdd] = useState(false);
  const [customerData, setCustomerData] = useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);

  //function for fetching property data based on the property id

  // ----------------------------------------------------------------------
  const [hotelData, setHotelData] = useState([]);
  const params = useParams();
  const hotelId = params.id;

  const fetchHotelData = async () => {
    try {
      const response = await getApi(`api/hotel/view/${hotelId}`);
      setHotelData(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAllCustomer = async () => {
    try {
      const response = await getApi(`api/customer/viewallcustomer/${hotelId}`);
      console.log("here response ===>",response);
      setCustomerData(response.data.customerData);

    } catch (error) {
      console.log("Found error =>",error);
    }
  }




  useEffect(() => {
    fetchHotelData();
    fetchAllCustomer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAdd]);

  return (
    <>
      <AddHotel open={openAdd} handleClose={handleCloseAdd} />
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between' }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example" textColor="secondary" indicatorColor="secondary">
              <Tab label="Information" value="1" />
              <Tab label="Customer Information" value="2" />
            </TabList>

            <div>
              <Select value="" displayEmpty inputProps={{ 'aria-label': 'Select option' }} sx={{ marginBottom: '12px' }}>
                <MenuItem value="" disabled>
                  Action
                </MenuItem>
                <MenuItem onClick={handleOpenAdd} sx={{ color: '#4CAF50' }}>
                  <AddIcon sx={{ marginRight: 1 }} />
                  Add
                </MenuItem>
              </Select>
              <Button
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                sx={{ marginLeft: 2, color: '#673ab7', borderColor: '#673ab7' }}
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
            </div>
          </Box>
          <TabPanel value="1">
            <Box sx={{ flexGrow: 1, overflowX: 'auto' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  {/* //-------------------- */}
                  <Item sx={{ height: '100%' }}>
                    <Typography variant="h4" fontWeight="bold">
                      Hotel ( {hotelData?.name} ) Information
                    </Typography>
                    <hr />
                    <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">Hotel Name</Typography>
                        <Typography style={{ color: 'black' }}>{hotelData.name ? hotelData?.name : 'N/A'}</Typography>
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">Email :</Typography>
                        <Typography style={{ color: 'black' }}>{hotelData.email ? hotelData.email : 'N/A'}</Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">Contact :</Typography>
                        <Typography style={{ color: 'black' }}>{hotelData.contact ? hotelData.contact : 'N/A'}</Typography>
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">Address :</Typography>
                        <Typography style={{ color: 'black' }}>{hotelData.address ? hotelData.address : 'N/A'}</Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">Map Url:</Typography>
                        {hotelData.mapurl ? (
                          <a
                            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(hotelData.mapurl)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Open in Google Maps
                          </a>
                        ) : (
                          <Typography style={{ color: 'black' }}>N/A</Typography>
                        )}
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">GST Number :</Typography>
                        <Typography style={{ color: 'black' }}>{hotelData.gstNumber ? hotelData.gstNumber : 'N/A'}</Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">Food GST Percentage:</Typography>
                        <Typography style={{ color: 'black' }}>{hotelData.gstNumber ? hotelData.gstNumber : 'N/A'}</Typography>
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">Room GST Percentage:</Typography>
                        <Typography style={{ color: 'black' }}>
                          {hotelData.roomgstpercentage ? hotelData.roomgstpercentage : 'N/A'}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid item xs={6} md={12} sx={{ marginTop: '10px' }}>
                      <Grid item xs={6} md={12} sx={{ marginTop: '10px' }}>
                        <Typography variant="h5">Joined Date :</Typography>
                        {hotelData.createdDate ? (
                          <Typography variant="body1">{moment(hotelData.createdDate).format('YYYY-MM-DD ( hh : mm : ss )')}</Typography>
                        ) : (
                          <Typography variant="body1">N/A</Typography>
                        )}
                      </Grid>
                    </Grid>
                  </Item>
                </Grid>
              </Grid>
            </Box>
          </TabPanel>
          <TabPanel value="2">
            <Box sx={{ flexGrow: 1, overflowX: 'auto' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  {/* //-------------------- */}
                  <Item sx={{ height: '100%' }}>
                    <Typography variant="h4" fontWeight="bold">
                    Hotel ( {hotelData?.name} ) Customer Information
                    </Typography>
                    <hr />

                    <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Name</TableCell>
                          <TableCell>Email</TableCell>
                          <TableCell>Address</TableCell>
                          <TableCell>Contact</TableCell>
                          <TableCell>Id Card Type</TableCell>
                          <TableCell>Id Card Number</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                          {customerData.map((customer) => (
                          <TableRow key={customer._id}>
                            <TableCell>{customer.fullName}</TableCell>
                            <TableCell>{customer.email}</TableCell>
                            <TableCell>{customer.address}</TableCell>
                            <TableCell>{customer.phoneNumber}</TableCell>
                            <TableCell>{customer.idCardType}</TableCell>
                            <TableCell>{customer.idcardNumber}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  </Item>
                </Grid>
              </Grid>
            </Box>
          </TabPanel>
        </TabContext>
      </Box>
    </>
  );
}
